module.exports = __webpack_public_path__ + "media/buy-now/sample_box10-731fcc24.png";